import { useSelector } from 'react-redux';

function useShortCode() {
  const org = useSelector(state => state.organisationReducer);
  return org ? org.ShortCode : null;
}

export default useShortCode;
